import React, { Component } from 'react'
import LoadingOverlay from 'react-loading-overlay';
import { SpinnerCircular } from 'spinners-react';

export default class Loader extends Component {
    render() {
        return (
            <React.Fragment>
                <div className='lodar-box-sec' style={{
                    position: "fixed",
                    zIndex: "1001",
                    left: "0",
                    top: "0",
                    width: "100%",
                    height: "100%",
                    overflow: "auto",
                    backgroundColor: "rgba(0,0,0,0.5)",
                    padding: "20%",

                }}>
                    <LoadingOverlay
                        active={true}
                        spinner={<SpinnerCircular color={'rgb(13 31 64)'} />}
                    >
                    </LoadingOverlay>
                </div>
            </React.Fragment>
        )
    }
}
